<template>
  <i class="fa fa-refresh fa-spin" />
</template>

<script>
/**
 * Анимированная Иконка-спиннер.
 */
export default {
  name: 'CSpinner'
}
</script>
